import { SynopsisObject } from "./data.types";
import styles from "../Menu.module.scss";

export const MenuContentSynopsis = ({
  synopsisData,
}: {
  synopsisData: SynopsisObject;
}) => {
  const { description, tagline, credits } = synopsisData;

  return (
    <div className={styles.synopsisWrapper}>
      <div className={styles.synopsisContainer}>
        <div className={styles.synopsisTextWrapper}>
          <div className={styles.synopsisIntro}>
            <h2>Synopsis</h2>
            {description && <p className={styles.description}>{description}</p>}
            {tagline && <p className={styles.tagline}>{tagline}</p>}
          </div>
          {credits && credits.length > 0 && (
            <div className={styles.creditsWrapper}>
              {credits.map(({ columnTitle, names }, index) => {
                if (!names || names.length === 0) return null;

                return (
                  <div key={`${columnTitle}-${index}`}>
                    <h3>{columnTitle}</h3>
                    <ul>
                      {names.map((name, index) => (
                        <li key={`${name}-${index}`}>{name}</li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className={styles.synopsisPoster}>
          <img src="/skillhouse-movie-poster.jpeg" alt="Skillhouse poster" />
        </div>
      </div>
    </div>
  );
};
